import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
);

ChartJS.register({
  id: 'customSpacingLegend',
  beforeInit(chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height += 15;
    }
  },
});

export default function LineChart(props) {

  const isInt = (n) => {
    return n % 1 === 0;
  }

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: 'auto',
        borderRadius: 4,
        color: 'white',
        font: {
          weight: 'bold'
        },
        formatter: Math.round,
        padding: 6,
        anchor: "end",
        offset: -20,
        align: "start"
      },
      legend: {
        position: 'top',
        labels: {
          color: '#FFFFFFB3',
        }
      },
      title: {
        display: true,
        color: "#D3AF5F",
        text: props.title ? props.title : '',
        font: {
          size: 16,
        }
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#FFFFFFB3'
        },
        grid: {
          borderColor: '#FFFFFFB3'
        }
      },
      y: {
        ticks: {
          color: '#FFFFFFB3',
          callback: function (val, index) {
            // Hide the label if it's a float
            return isInt(val) ? this.getLabelForValue(val) : '';
          },
        },
        grid: {
          borderColor: '#FFFFFFB3'
        }
      },
    }
  };

  const data = {
    labels: props.stats ? props.stats.map(stat => stat.date)
      :
      props.statToGraph ? props.statToGraph.stats.labels.map(elem => elem)
        :
        [],
    datasets: [
      {
        label: props.statToGraph ? props.statToGraph.title : props.title,
        data: props.stats ? props.stats.map(stat => stat.y)
          :
          props.statToGraph ? props.statToGraph.stats.values.map(elem => elem)
            :
            [],
        borderColor: "rgb(211, 175, 95)",
        backgroundColor: "rgba(211, 175, 95, 0.5)",
      }
    ]
  };

  return (
    <Line
      options={options}
      data={data}
      height={props.responsive ? 300 : 'auto'}
      width={props.responsive ? 400 : 'auto'}
    />
  );
}
